'use strict';

const { pubdb } = Function('return this')();
const {
    $, window, ajax_post, echo, trim, next_tick, ajax_success_next_handler,
} = pubdb;
const { location, setTimeout } = window;


let form;

function req_success (resp) {
    ajax_success_next_handler(resp, 'author');
}

function req_error (data, err, xhr) {
    echo('warn', 'Fehler (' + data.statusText + ') ist beim Ändern der Autordaten aufgetreten - bitte versuchen Sie es erneut');
}

function onsubmit (ev) {
    ev.preventDefault();
    next_tick(function () {
        const data = {
            firstname: trim($('[name=firstname]',  form).val()),
            lastname: trim($('[name=lastname]',   form).val()),
            csrf_token: trim($('[name=csrf_token]', form).val()),
            we: +$('[name=we]', form).val(),
            id: +$('[name=id]', form).val()
        };
        ajax_post(form.attr('action'), data, req_success, req_error);
    });
}

$(function use_form () {
    // TODO: FIXME: warum ist das so unnötig kompliziert implementiert?
    form = $('.form form');
    if (!form.length) {
        form = $('form');
        if (!form.length) {
            setTimeout(use_form, 30);
            return;
        }
    }
    form.on('submit', onsubmit);
});
